import { render, staticRenderFns } from "./ProductMainDialog.vue?vue&type=template&id=5da2750d&scoped=true&"
import script from "./ProductMainDialog.vue?vue&type=script&lang=js&"
export * from "./ProductMainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da2750d",
  null
  
)

export default component.exports